<div *ngIf="{ class: classDetail, program: program } as detailData">
    <div class-roster-header>
        <ng-container *ngIf="program; else displayProgramErrorMessage">
            <div breadcrumb>
                <span>
                    <img src="assets/icons/programs-drawer-title.svg" alt="">
                </span>
                <p>{{detailData.program?.name}} • {{detailData.program?.startDate | dateFormat :'mm/dd/yy'}} -
                    {{detailData.program?.endDate
                    | dateFormat :'mm/dd/yy'}}</p>
            </div>
        </ng-container>
        <ng-template #displayProgramErrorMessage>
            <p class="background-white m-t-xs">
                <span class="m-l-lg">
                    <error-message [errorMessage]="programErrorMessage"></error-message>
                </span>
            </p>
        </ng-template>

        <ng-container *ngIf="classDetail?.length; else displayclassDetailErrorMessage">
            <div title>
                <h1>{{selectedClassDetails?.title}}</h1>
                <span
                    class="{{selectedClassDetails?.startDate |classcolor : selectedClassDetails?.endDate }}">{{selectedClassDetails?.startDate
                    | classstatus : selectedClassDetails?.endDate}}</span>
            </div>
            <div items>
                <div content>
                    <p>CLASS ID
                        <span dblock>{{displayClassId}}</span>
                    </p>
                </div>
                <div content>
                    <p>COURSE NUMBER
                        <span dblock>{{displayCourseId}}</span>
                    </p>
                </div>
                <div content>
                    <p>CHECK-IN CODE
                        <span dblock>{{selectedClassDetails?.checkInCode || 'N/A'}}</span>
                    </p>
                </div>

                <div content>
                    <p>DATE</p>

                    <div>
                        <div class="sub-header">{{selectedClassDetails?.startDate | dateFormat : 'mmddyyyy'}}</div>
                        <div class="sub-header-day-count">{{selectedClassDetails?.startDate | dateFormat
                            :'fulldayname'}}</div>
                    </div>
                </div>
                <div content>
                    <p>TIME</p>
                    <div>
                        <div class="sub-header">{{selectedClassDetails?.startDate |dateFormat : 'coursetime'}} -</div>
                        <div class="sub-header">{{selectedClassDetails?.endDate |dateFormat : 'coursetime'}}</div>
                    </div>
                </div>
                <div content>
                    <p>ROOM</p>
                    <div class="sub-header">
                        {{selectedClassDetails?.location || 'TBD'}}</div>
                </div>
                <div content class="check-in-users">
                    <p>CHECKED-IN USERS</p>
                    <div class="sub-header">{{selectedClassDetails?.checkedInUsersCount}}</div>
                </div>
            </div>
        </ng-container>

        <ng-template #displayclassDetailErrorMessage>
            <p class="background-white m-t-xs">
                <span class="m-l-lg">
                    <error-message [errorMessage]="classDetailErrorMessage"></error-message>
                </span>
            </p>
        </ng-template>

    </div>
    <div cr-popup-body>
        <class-roster [programId]="programId" [classId]="classId"
            [reportName]="detailData.program?.sabaProgramId + '_' + displayClassId" [classDate]="classDate"
            [classEndDate]="classEndDate" (editedIndexEvent)="selectedEvent($event)"
            (isAnyFormOpen)="anyTimeInputFormOpen($event)"
            [facilitatorAttendance]="facilitatorAttendance"></class-roster>
    </div>
</div>